module.exports = __webpack_public_path__ + "static/img/img03.9086ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img03.png
// module id = TSR/
// module chunks = 1